import React from 'react'
import "./primaryButton.scss";
import { Link } from 'react-router-dom';

export default function Pbutton(props) {
  return (
    <div className='btn_body'>      
      <a href={props.link}  className="m-btn m-btn-secondary">
        <span className="m-text m-text-1">{props.label}</span>
        <span className="m-text m-text-2" aria-hidden="true">{props.label}</span>
      </a>
    </div>
  )
}
